module.exports = __webpack_public_path__ + "static/media/warmup2.cb41daec.png";